import styled from 'styled-components';

export default styled.div`
  && {
    height: 66px;
    background-color: #ecffb8;
    padding: 15px 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    .btn-change-display-month {
      width: 149px;
      height: 35px;
      background-color: #ff8a00;
      border-radius: 5px;
      border: none;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);
      color: white;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .ant-col-12 {
      max-width: 47%;
    }
  }
`;
